<h2>
  {{ text1 }} <span class="highlighted">{{ text2 }}</span> {{ text3 }}
</h2>
<div class="row w100">
  <textarea
    [formControl]="control"
    [placeholder]="placeholder"
    [rows]="row"
    wrap="hard"
    [value]="textareaValue"
    (input)="onInput($event)"
    class="w100"
    #textarea
  ></textarea>
  <div class="ai pointer">
    <!-- <rr-icon
      name="ai"
      *ngIf="aiIsRunning === false"
      [ngClass]="totalDiabledStatus === true ? 'disabled' : ''"
      (click)="startAiQuery()"
    ></rr-icon> -->
    <div
      class="loading-icon"
      *ngIf="aiIsRunning === true"
      (click)="stopAiQuery()"
    >
      <div class="spinner-border"></div>
      <rr-icon name="ai"></rr-icon>
    </div>
  </div>
</div>
<!-- <div
  class="agentrow space-between row gap-8 align-centerſ"
  *ngIf="showAgentRow === true"
>
  <rr-agent-select></rr-agent-select>
  <rr-icon name="pause" class="pointer" (click)="stopAiQuery()"></rr-icon>
</div> -->
<div class="btnrow row space-between">
  <rr-btn
    i18n
    type="Primary"
    [disabled]="totalDiabledStatus || nextDisabled"
    (click)="
      totalDiabledStatus === true || nextDisabled === true
        ? null
        : next.emit(textarea.value)
    "
    >Next</rr-btn
  >
  <!-- <rr-btn
    i18n
    type="Secondary"
    iconStart="ai"
    (click)="autoFillDisabled === true ? null : autofill.emit(control.value)"
    [disabled]="autoFillDisabled"
    >Auto Fill ALL</rr-btn
  > -->
  <rr-btn
    i18n
    type="Secondary"
    iconStart="ai"
    (click)="autoFillDisabled === true ? null : supportme.emit(control.value)"
    [disabled]="autoFillDisabled"
    >Support me</rr-btn
  >
</div>
<div
  class="suggestions col gap-12 w100"
  *ngIf="suggestions.length > 0 && showAgentSuggestions === true"
>
  <div
    class="suggestion row w100 gap-8 align-center pointer"
    *ngFor="let sug of suggestions"
    (click)="addSuggestionToTextarea(sug)"
  >
    <rr-icon name="ai"></rr-icon>
    <div class="suggestion_content" markdown ngPreserveWhitespaces>
      {{ sug.text || sug }}
    </div>
  </div>
</div>
